'use strict';
const AncillariesTracking = require('./ancillaries_base');
const TRACKING_TYPE = new Odigeo.Enum(['short', 'long', 'more', 'disclosure']);

const LABEL_CATEGORIES = [
    'CANC',
    'CANCASS',
    'COMPREH',
    'ANYREASON',
    'FLEX',
    'ASS',
    'HUB',
    'LUG',
    'EXTRA',
    'DELAY',
    'BANKRUPTCY',
    AncillariesTracking.UNKNOWN_CLASSES_ENUM.UNKNOWN,
];
const LABEL_EXPANDED_CATEGORIES_INTO_POLICIES = [
    'CANC',
    'CANCASS',
    'COMPREH',
    'ANYREASON',
    'FLEX',
    'ASS',
    'HUB',
    'LUG',
    'ESTA',
    'EVISA',
    'AUTO_CHECKIN',
    'CONFIRMATION_SMS',
    'BAGGAGE_ASSISTANCE',
    'DELAY',
    'BANKRUPTCY',
    'SO',
    AncillariesTracking.UNKNOWN_CLASSES_ENUM.UNKNOWN,
];
const LABEL_CATEGORIES_ENUM = new Odigeo.Enum(LABEL_CATEGORIES);
const LABEL_CATEGORIES_BY_POLICY = {
    '1-26-5251592': LABEL_CATEGORIES_ENUM.CANC,
    'CNXFLT151': LABEL_CATEGORIES_ENUM.CANC,
    'CANX_AX01': LABEL_CATEGORIES_ENUM.CANC,
    'CNXFHL157': LABEL_CATEGORIES_ENUM.CANC,
    'UKCANX_AX10': LABEL_CATEGORIES_ENUM.CANC,
    'G-AIRI01': LABEL_CATEGORIES_ENUM.CANC,
    'G-AIRI02': LABEL_CATEGORIES_ENUM.CANC,
    'CNXFHL154': LABEL_CATEGORIES_ENUM.CANC,
    'CANXDP_AX03': LABEL_CATEGORIES_ENUM.CANC,
    'CNXHOT155': LABEL_CATEGORIES_ENUM.CANC,
    '55-0009760': LABEL_CATEGORIES_ENUM.CANCASS,
    'CNXAST152': LABEL_CATEGORIES_ENUM.CANCASS,
    'CANASS_AX02': LABEL_CATEGORIES_ENUM.CANCASS,
    'CNXAST158': LABEL_CATEGORIES_ENUM.CANCASS,
    'UKMULTI_AX12': LABEL_CATEGORIES_ENUM.CANCASS,
    'G-AIRD01': LABEL_CATEGORIES_ENUM.CANCASS,
    'G-AIRD02': LABEL_CATEGORIES_ENUM.CANCASS,
    'COMPREH163': LABEL_CATEGORIES_ENUM.COMPREH,
    'COMPRE_AX09': LABEL_CATEGORIES_ENUM.COMPREH,
    'CANXSELF': LABEL_CATEGORIES_ENUM.ANYREASON,
    'FLEXSELF': LABEL_CATEGORIES_ENUM.FLEX,
    'FLEXRB156': LABEL_CATEGORIES_ENUM.FLEX,
    'FLEXRB160': LABEL_CATEGORIES_ENUM.FLEX,
    'FLEXUK164': LABEL_CATEGORIES_ENUM.FLEX,
    'FLEX_AX04': LABEL_CATEGORIES_ENUM.FLEX,
    'UKFLEX_AX11': LABEL_CATEGORIES_ENUM.FLEX,
    'ASTONL162': LABEL_CATEGORIES_ENUM.ASS,
    'NEWHUB162': LABEL_CATEGORIES_ENUM.HUB,
    'HUB_AX05': LABEL_CATEGORIES_ENUM.HUB,
    'INSLUG159': LABEL_CATEGORIES_ENUM.LUG,
    'LUGPRM161': LABEL_CATEGORIES_ENUM.LUG,
    'CONFIRMATION_SMS': LABEL_CATEGORIES_ENUM.EXTRA,
    'BAGGAGE_ASSISTANCE': LABEL_CATEGORIES_ENUM.EXTRA,
    'POSTED_TICKET': LABEL_CATEGORIES_ENUM.EXTRA,
    'EVISA': LABEL_CATEGORIES_ENUM.EXTRA,
    'ESTA': LABEL_CATEGORIES_ENUM.EXTRA,
    'AUTO_CHECKIN': LABEL_CATEGORIES_ENUM.EXTRA,
    'DELAY': LABEL_CATEGORIES_ENUM.DELAY,
    'SAFINS165': LABEL_CATEGORIES_ENUM.BANKRUPTCY,
};

const EVENT_ACTIONS = [
    'ancillary_onload',
    'ancillary_selection',
    'ancillary_information',
    'possible_CTA',
    'back_and_errors',
    'nags',
    'automatic_checkin',
];
const EVENT_ACTIONS_ENUM = new Odigeo.Enum(EVENT_ACTIONS);

const POLICY = AncillariesTracking.POLICY;
const CATEGORY = AncillariesTracking.CATEGORY;
const PAGE = AncillariesTracking.PAGE;

const EVENTS_DICTIONARY = {
    'onload': {
        'action': EVENT_ACTIONS_ENUM.ancillary_onload,
        'label': `ancillary_product_onload_pol:${POLICY}_pag:${PAGE}`,
    },
    'onload_checkin': {
        'action': EVENT_ACTIONS_ENUM.automatic_checkin,
        'label': `automatic-checkin_onlyhandbag_onload`,
    },
    'add': {
        'action': EVENT_ACTIONS_ENUM.ancillary_selection,
        'label': `ancillary_product_add_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'add_from_details': {
        'action': EVENT_ACTIONS_ENUM.ancillary_selection,
        'label': `ancillary_details_add_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'negate': {
        'action': EVENT_ACTIONS_ENUM.ancillary_selection,
        'label': `ancillary_product_no_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'remove': {
        'action': EVENT_ACTIONS_ENUM.ancillary_selection,
        'label': `ancillary_product_remove_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'open_details': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `ancillary_open_details_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'close_details': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `ancillary_close_details_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'open_coverage': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `ancillary_open_coverage_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'close_coverage': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `ancillary_close_coverage_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'conditions_short': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `ancillary_open_conditionsshort_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'conditions_long': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `ancillary_open_conditionslong_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'conditions_more': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `ancillary_open_conditionsmore_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'conditions_disclosure': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `ancillary_open_conditionsdisclosure_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'ipid': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `ancillary_open_ipid_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'continue': {
        'action': EVENT_ACTIONS_ENUM.ancillary_selection,
        'label': `ancillary_product_selected_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'error': {
        'action': EVENT_ACTIONS_ENUM.back_end_errors,
        'label': `${POLICY}_error`,
    },
    'mandatory_selection_error': {
        'action': EVENT_ACTIONS_ENUM.back_and_errors,
        'label': `ancillary_mandatory_error_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'nag': {
        reject: {
            appears: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_reject_appearances`,
            },
            accept: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_reject_add`,
            },
            reject: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_reject_continue`,
            },
        },
        continuance: {
            appears: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_submit_appearances`,
            },
            accept: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_submit_add`,
            },
            reject: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_submit_continue`,
            },
            tryclose: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_submit_tryclose`,
            },
        },
        confirmation: {
            appears: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_confirmation_appearances`,
            },
            accept: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_confirmation_add`,
            },
            reject: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_confirmation_continue`,
            },
        },
        delay: {
            appears: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_smoke_appearances`,
            },
            accept: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_smoke_continue`,
            },
        },
    },
};

const TRACKING_PAGES = {
    desktop: {
        'payment': 'ancillaries',
    },
    mobile: {
        'ancillaries/canx': 'canx',
        'ancillaries/flex': 'flex',
        'ancillaries/insurance': 'insurance',
        'ancillaries/selection': 'selection',
        'ancillaries/additions': 'additions',
    },
};

class AncillariesTrackingGuarantees extends AncillariesTracking {
    constructor(product) {
        super(
            product,
            EVENTS_DICTIONARY,
            LABEL_CATEGORIES,
            LABEL_CATEGORIES_BY_POLICY,
            TRACKING_PAGES,
            {},
            LABEL_EXPANDED_CATEGORIES_INTO_POLICIES
        );
    }

    clickConditionsFromPopup(policy, type) {
        let trackingType;
        switch (type) {
            case TRACKING_TYPE.short:
            case TRACKING_TYPE.long:
            case TRACKING_TYPE.more:
            case TRACKING_TYPE.disclosure:
                trackingType = type;
                break;
            default:
                trackingType = TRACKING_TYPE.long;
                break;
        }
        this.trackEvent(`conditions_${trackingType}`, policy);
    }
}

AncillariesTrackingGuarantees.prototype.noButton = AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('negate');
AncillariesTrackingGuarantees.prototype.addProductFromDetails = AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('add_from_details');
AncillariesTrackingGuarantees.prototype.openCoverage = AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('open_coverage');
AncillariesTrackingGuarantees.prototype.closeCoverage = AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('close_coverage');
AncillariesTrackingGuarantees.prototype.openConditionsShort = AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('conditions_short');
AncillariesTrackingGuarantees.prototype.openConditionsLong = AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('conditions_long');
AncillariesTrackingGuarantees.prototype.openConditionsDisclosure =
    AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('conditions_disclosure');
AncillariesTrackingGuarantees.prototype.openIpid = AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('ipid');
AncillariesTrackingGuarantees.prototype.openConditionsMore = AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('conditions_more');
AncillariesTrackingGuarantees.prototype.error = AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('error');
AncillariesTrackingGuarantees.prototype.mandatorySelectionError =
    AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('mandatory_selection_error');
AncillariesTrackingGuarantees.prototype.onloadCheckin = AncillariesTrackingGuarantees.prototype.prepareTrackEventFunction('onload_checkin');

module.exports = AncillariesTrackingGuarantees;
